import Vue from 'vue';
import Router from 'vue-router';
import AccountService from '@/api/AccountService';

import LoginRoutes from '@/router/routes/login';
import ProfileRoutes from '@/router/routes/profile';
import InformationPageRoutes from '@/router/routes/informationPage';
import ContactUsRoutes from '@/router/routes/contactUs';
import TimeEntryRoutes from '@/router/routes/timeEntry';
import CalendarRoutes from '@/router/routes/calendar';
import EmployersRoutes from '@/router/routes/employers';
import ErrorsRoutes from '@/router/routes/errors';

import store from '@/stores';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: []
    .concat(LoginRoutes)
    .concat(ProfileRoutes)
    .concat(TimeEntryRoutes)
    .concat(CalendarRoutes)
    .concat(EmployersRoutes)
    .concat(ErrorsRoutes)
    .concat(InformationPageRoutes)
    .concat(ContactUsRoutes),
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  store.commit('loading/viewPending', true);
  if (!store.state.user.isLoggedIn) {
    store.dispatch('user/init');
  }

  // if the user is already logged-in, don't go on login pages
  const logins = ['login', 'forgot-password', 'member-authentication'];
  const isLogged = store.state.user.isLoggedIn;
  if (to.matched && logins.includes(to.matched[0].name) && isLogged) {
    return next({ path: '/dashboard' });
  }

  // if the page requires authentication
  if (to.matched && to.matched.some(record => record.meta.requiresAuth)) {
    // if the user is logged, we validate through the API, else et go to login page
    if (isLogged) {
      return AccountService.isLoggedIn()
        .then(() => {
          if (!store.state.member.selectedMember || !store.state.member.selectedMember.language) {
            store.dispatch('member/currentMember');
          }
          return next();
        });
    }
    return next({ path: '/', query: { rurl: encodeURI(to.path) } });
  }

  return next();
});

router.afterEach(() => {
  store.commit('loading/viewPending', false);

  const doc = document.getElementsByClassName('container-fluid');
  if (doc && doc[0]) {
    doc[0].scrollIntoView(true);
  }
});

export default router;
